// Since we only care about displaying Chroma as a single product to the client
// no matter the tier, we only show a Chroma group in order for the Admin
// to add training videos to. In the future, if we need to add content based on specific tier
// we can get rid of this allowing the admin to add content based on tier
// and implement an option in the customer side to display traning videos
// based on selected tier as well
import { isChroma } from './isChroma';

export const filterGroups = (groups, text = '') => {
  return groups
    .filter(g => !g.name.toLowerCase().includes(text.toLowerCase()))
    .map(g => (isChroma(g.name) ? { ...g, name: 'Chroma' } : g));
};
